// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"325":"form","806":"user","853":"table"}[chunkId] || chunkId) + "." + {"325":"7f8525ce","806":"859dc522","853":"d0c31c9f","901":"1a24b1cf"}[chunkId] + ".css";
};